(function () {
  'use strict';

  if (window._vapCardInteractionsLoaded) return;
  window._vapCardInteractionsLoaded = true;

  /* ---- Wishlist badge ---- */
  window.vapUpdateWishlistBadge = function () {
    var n = 0;
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf('vap_wl_') === 0 && localStorage.getItem(k)) n++;
    }
    var badge = document.getElementById('vap-wl-header-count');
    var link  = document.getElementById('vap-header-wishlist');
    if (badge) { badge.textContent = n; badge.hidden = n === 0; }
    if (link)  link.classList.toggle('has-items', n > 0);
  };

  /* ---- Toast ---- */
  window.vapShowToast = function (title, type, subtitle) {
    var container = document.getElementById('vap-toast-container');
    if (!container) return;
    var isAdd = type === 'add';
    var toast = document.createElement('div');
    toast.className = 'vap-toast vap-toast--' + (isAdd ? 'add' : 'remove');
    toast.innerHTML =
      '<div class="vap-toast__icon">'
        + '<svg viewBox="0 0 24 24" fill="' + (isAdd ? '#ef4444' : 'none') + '" stroke="' + (isAdd ? '#ef4444' : '#94a3b8') + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
          + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
        + '</svg>'
      + '</div>'
      + '<div class="vap-toast__content">'
        + '<p class="vap-toast__title">' + title + '</p>'
        + (subtitle ? '<p class="vap-toast__sub">' + subtitle.substring(0, 48) + (subtitle.length > 48 ? '…' : '') + '</p>' : '')
      + '</div>'
      + '<button class="vap-toast__close" type="button" aria-label="Dismiss">'
        + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '<div class="vap-toast__progress"></div>';
    container.appendChild(toast);
    function dismiss() {
      if (toast._done) return;
      toast._done = true;
      toast.classList.add('is-leaving');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 320);
    }
    var timer = setTimeout(dismiss, 3200);
    toast.querySelector('.vap-toast__close').addEventListener('click', function () {
      clearTimeout(timer); dismiss();
    });
  };

  function initWishlist() {
    /* One full localStorage scan into a Set — O(1) per button instead of O(N) reads */
    var wishlisted = new Set();
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf('vap_wl_') === 0 && localStorage.getItem(k)) {
        wishlisted.add(k.slice(7));
      }
    }
    document.querySelectorAll('.vap-wishlist-btn[data-product-id]').forEach(function (btn) {
      if (wishlisted.has(btn.dataset.productId)) btn.classList.add('is-wishlisted');
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.vap-wishlist-btn[data-product-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var pid = btn.dataset.productId;
      var active = btn.classList.toggle('is-wishlisted');

      if (active) {
        btn.classList.add('vap-wl-pop');
        btn.addEventListener('animationend', function () {
          btn.classList.remove('vap-wl-pop');
        }, { once: true });
        localStorage.setItem('vap_wl_' + pid, btn.dataset.productHandle || pid);
      } else {
        localStorage.removeItem('vap_wl_' + pid);
      }

      if (typeof window.vapUpdateWishlistBadge === 'function') window.vapUpdateWishlistBadge();
      if (typeof window.vapShowToast === 'function') {
        var card = btn.closest('.vap-common-card-block');
        var titleEl = card ? card.querySelector('.vap-product-name') : null;
        window.vapShowToast(
          active ? 'Added to Wishlist' : 'Removed from Wishlist',
          active ? 'add' : 'remove',
          titleEl ? titleEl.textContent.trim() : ''
        );
      }
    });
  }

  function initAtcFeedback() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-type="add-to-cart-form"]')) return;
      var btn = form.querySelector('button.vap-cart[type="submit"]');
      if (btn) btn.classList.add('is-loading');
    });

    document.addEventListener('cart:updated', function () {
      document.querySelectorAll('button.vap-cart.is-loading').forEach(function (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWishlist();
      initAtcFeedback();
      window.vapUpdateWishlistBadge();
    });
  } else {
    initWishlist();
    initAtcFeedback();
    window.vapUpdateWishlistBadge();
  }
})();
